import { render, staticRenderFns } from "./CommunityCommentNode.vue?vue&type=template&id=11d290d2&scoped=true&"
import script from "./CommunityCommentNode.vue?vue&type=script&lang=js&"
export * from "./CommunityCommentNode.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCommentNode.vue?vue&type=style&index=0&id=11d290d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d290d2",
  null
  
)

export default component.exports